import axiosInstance from './axiosInstance';

const updateDashboardTransactions = ({ address, currencyNetworkId }) =>
  axiosInstance.post(
    '/internal/admin/blockchain/dashboard/update_transactions',
    { address, crypto_network_id: currencyNetworkId },
  );

export default updateDashboardTransactions;
